import React, { useEffect, useState } from 'react';
import {
  Button,
  Illustration,
  type IllustrationKind,
} from '@saviynt/design-system';

import FormLayout from './FormLayout';

import './ConfirmationDialog.css';

interface Props {
  /** callback after 5s timeout, should be stable for use in dependency array */
  onContinue: () => void;
  title: string;
  subtitle: string;
  continueLabel: (countdown: number) => string;
}

/** Shows a confirmation message and redirects to homepage after 5 seconds */
export default function ConfirmationDialog({
  onContinue: handleInteraction,
  title,
  subtitle,
  continueLabel,
}: Props): JSX.Element {
  const [countdown, setCountdown] = useState(5);
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    if (isCounting) {
      return;
    }

    if (countdown > 0) {
      setIsCounting(true);

      setTimeout(() => {
        setIsCounting(false);
        setCountdown((prev) => prev - 1);
      }, 1000);

      return;
    }

    handleInteraction();
  }, [countdown, isCounting, handleInteraction]);

  return (
    <FormLayout
      title={title}
      footerContent={footer()}
      onSubmit={handleInteraction}>
      {subtitle}
      <Illustration
        kind={'Confirmation' as IllustrationKind /* bug in DS types build? */}
      />
    </FormLayout>
  );

  function footer() {
    return (
      <Button
        className='Auth_ConfirmationDialog-button'
        onClick={handleInteraction}>
        {continueLabel(countdown)}
      </Button>
    );
  }
}
